import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "file-drop file-drop--container" }
const _hoisted_2 = {
  key: 0,
  class: "file-drop--image"
}
const _hoisted_3 = ["id", "accepts"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "filetypes" }
const _hoisted_7 = {
  key: 1,
  class: "file-drop__default"
}
const _hoisted_8 = ["id", "accept"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "file-drop__label--wrapper" }
const _hoisted_11 = { class: "file-drop__label-title" }
const _hoisted_12 = { class: "drop-label__title drop-label__title--bold" }
const _hoisted_13 = { class: "drop-label__subtitle-container" }
const _hoisted_14 = { class: "drop-label__subtitle" }
const _hoisted_15 = { class: "drop-label__subtitle" }
const _hoisted_16 = {
  key: 0,
  class: "file-drop__files-container"
}
const _hoisted_17 = {
  key: 0,
  class: "file-description"
}
const _hoisted_18 = {
  class: "file-name",
  style: {"text-align":"left","padding-left":"1.2rem"}
}
const _hoisted_19 = { class: "file-actions" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("input", {
            class: "file-drop--image__input",
            type: "file",
            multiple: false,
            id: `imageFileDrop_${_ctx.id}`,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
            ref: "imageInput",
            accepts: _ctx.accepts,
            onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
            onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args)))
          }, null, 40, _hoisted_3),
          _createElementVNode("label", {
            class: "file-drop--image__label",
            for: `imageFileDrop_${_ctx.id}`
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.label), 1),
            _createElementVNode("div", _hoisted_6, "(" + _toDisplayString(_ctx.accepts.join(', ')) + " )", 1)
          ], 8, _hoisted_4)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "input", {
            id: `fileDrop_${_ctx.id}`,
            actions: { onChange: _ctx.onChange, remove: _ctx.remove, dragover: _ctx.dragover, dragleave: _ctx.dragleave, drop: _ctx.drop },
            data: _ctx.csvData,
            fileList: _ctx.fileList,
            file: _ctx.file,
            accepts: _ctx.accepts
          }, () => [
            _createElementVNode("input", {
              class: "file-drop__input",
              "data-cy": "file-drop__input",
              type: "file",
              multiple: false,
              id: `fileDrop_${_ctx.id}`,
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
              ref: "fileInput",
              accept: String(_ctx.accepts),
              onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
              onDragleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args)))
            }, null, 40, _hoisted_8)
          ]),
          _renderSlot(_ctx.$slots, "label", {
            id: `fileDrop_${_ctx.id}`,
            actions: { onChange: _ctx.onChange, remove: _ctx.remove, dragover: _ctx.dragover, dragleave: _ctx.dragleave, drop: _ctx.drop },
            data: _ctx.csvData,
            fileList: _ctx.fileList,
            file: _ctx.file,
            accepts: _ctx.accepts
          }, () => [
            _createElementVNode("label", {
              class: "file-drop__label",
              for: `fileDrop_${_ctx.id}`
            }, [
              _createElementVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "content", {
                  id: `fileDrop_${_ctx.id}`,
                  actions: { onChange: _ctx.onChange, remove: _ctx.remove, dragover: _ctx.dragover, dragleave: _ctx.dragleave, drop: _ctx.drop },
                  data: _ctx.csvData,
                  fileList: _ctx.fileList,
                  file: _ctx.file,
                  accepts: _ctx.accepts
                }, () => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.label), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "drop-label__title drop-label__title--underlined" }, "or click to browse", -1))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accepts, (fileType) => {
                        return (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(fileType.startsWith('.') ? fileType : `.${fileType}`), 1))
                      }), 256)),
                      _createElementVNode("span", _hoisted_15, "(max. " + _toDisplayString(_ctx.max) + " " + _toDisplayString(_ctx.max > 1 ? 'files' : 'file') + ")", 1)
                    ])
                  ])
                ]),
                (_ctx.fileList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "file-drop__file",
                          key: `file--${i}`
                        }, [
                          (!_ctx.isImage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _renderSlot(_ctx.$slots, "description", {
                                  id: `fileDrop_${_ctx.id}`,
                                  actions: { onChange: _ctx.onChange, remove: _ctx.remove, dragover: _ctx.dragover, dragleave: _ctx.dragleave, drop: _ctx.drop },
                                  data: _ctx.csvData,
                                  fileList: _ctx.fileList,
                                  file: file,
                                  accepts: _ctx.accepts
                                }, () => [
                                  _createVNode(_component_q_icon, {
                                    class: "file-icon",
                                    size: "xs",
                                    style: {"color":"#081137","position":"absolute"},
                                    flat: "",
                                    round: "",
                                    dense: "",
                                    name: "svguse:icons/essential/30-document.svg"
                                  }),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(file.name), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", {
                              class: "file-action file-action--remove",
                              onClick: _withModifiers(($event: any) => (_ctx.remove(_ctx.fileList.indexOf(file))), ["prevent","stop"])
                            }, "Remove file", 8, _hoisted_20),
                            _renderSlot(_ctx.$slots, "actions", {
                              id: `fileDrop_${_ctx.id}`,
                              actions: { onChange: _ctx.onChange, remove: _ctx.remove, dragover: _ctx.dragover, dragleave: _ctx.dragleave, drop: _ctx.drop },
                              data: _ctx.csvData,
                              fileList: _ctx.fileList,
                              file: file,
                              accepts: _ctx.accepts
                            })
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_9)
          ])
        ]))
  ]))
}